import TweenMax from 'gsap/TweenMax';

export default function DiveDownDeep(
  container,
  canvas,
  duration,
  beforeAnimation
) {
  const {
    left: containerLeft,
    top: containerTop,
    height: containerHeight,
  } = container.getBoundingClientRect();
  const {
    left: canvasLeft,
    top: canvasTop,
    height: canvasHeight,
  } = canvas.getBoundingClientRect();
  const initialX = -(containerLeft - canvasLeft);
  const initialY = canvasTop - containerTop + containerHeight / 2;

  beforeAnimation(initialX, initialY);

  TweenMax.to(container, 0.1, {
    opacity: 1,
    onComplete: () => {
      TweenMax.to(container, duration - 0.1, {
        y: initialY + canvasHeight - (3 / 2) * containerHeight,
      });
    },
  });
}
